import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PhoneIcon from "@mui/icons-material/PhoneOutlined";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOnOutlined";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TelegramIcon from "@mui/icons-material/Telegram";
import StoreIcon from "@mui/icons-material/Store";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";

const TopBar = ({ isMobile, isTablet }) => {
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const { language, changeLanguage } = useLanguage();
  const { socialLinks } = useAuth();

  const toggleLanguageDropdown = () => {
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
  };

  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setIsLanguageDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isLanguageDropdownOpen &&
        !event.target.closest(".language-selector")
      ) {
        setIsLanguageDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isLanguageDropdownOpen]);

  // If mobile, don't render the TopBar
  if (isMobile) {
    return null;
  }

  return (
    <div className="navbar__top">
      <div className="container">
        <div className="navbar__top-right">
          <div className="navbar__top-right-item">
            <EmailIcon className="icon" />
            <span>houfalmanazel@gmail.com</span>
          </div>
          <div className="navbar__top-right-item">
            <PhoneIcon className="icon" />
            <span>0536785505</span>
          </div>
          {!isTablet && (
            <div className="navbar__top-right-item">
              <LocationOnIcon className="icon" />
              <span>
                {language === "ar" ? "السعودية" : "Saudi Arabia"}
              </span>
            </div>
          )}
        </div>
        <div className="navbar__top-left">
          <div className="language-selector">
            <div className="selected-language" onClick={toggleLanguageDropdown}>
              {language === "ar" ? (
                <span className="flag-text">
                  <img
                    src="https://flagcdn.com/sa.svg"
                    alt="KSA Flag"
                    className="flag-icon"
                  />
                  {!isMobile && "العربية"}
                </span>
              ) : (
                <span className="flag-text">
                  <img
                    src="https://flagcdn.com/us.svg"
                    alt="USA Flag"
                    className="flag-icon"
                  />
                  {!isMobile && "English"}
                </span>
              )}
              <ArrowDropDownIcon className="dropdown-icon" />
            </div>

            {isLanguageDropdownOpen && (
              <div className="language-dropdown">
                <div
                  className={`language-option ${
                    language === "ar" ? "active" : ""
                  }`}
                  onClick={() => handleLanguageChange("ar")}
                >
                  <img
                    src="https://flagcdn.com/sa.svg"
                    alt="KSA Flag"
                    className="flag-icon"
                  />
                  <span>العربية</span>
                </div>
                <div
                  className={`language-option ${
                    language === "en" ? "active" : ""
                  }`}
                  onClick={() => handleLanguageChange("en")}
                >
                  <img
                    src="https://flagcdn.com/us.svg"
                    alt="USA Flag"
                    className="flag-icon"
                  />
                  <span>English</span>
                </div>
              </div>
            )}
          </div>

          {/* Social Icons - Only show links that exist in socialLinks */}
          {socialLinks?.faceBookLink && (
            <Link
              to={socialLinks.faceBookLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon className="icon" />
            </Link>
          )}
          {socialLinks?.xLink && (
            <Link
              to={socialLinks.xLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon className="icon" />
            </Link>
          )}
          {!isTablet && (
            <>
              {socialLinks?.instagramLink && (
                <Link
                  to={socialLinks.instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon className="icon" />
                </Link>
              )}
              {socialLinks?.whatsAppLink && (
                <Link
                  to={socialLinks.whatsAppLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsAppIcon className="icon" />
                </Link>
              )}
              {socialLinks?.youTubeLink && (
                <Link
                  to={socialLinks.youTubeLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <YouTubeIcon className="icon" />
                </Link>
              )}
              {socialLinks?.telegramLink && (
                <Link
                  to={socialLinks.telegramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TelegramIcon className="icon" />
                </Link>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
